//@ts-nocheck
import * as React from 'react';
import renderHTML from 'react-render-html';
import ReactPaginate from 'react-paginate';
import { toCurrency } from '../../Common/Helpers';
import { FACT_SHEET_TABLE_PAGE_SIZE, getPageCount, getPageSlice } from './TablePaginationHelpers';


class StateLegislativeTable extends React.Component<Props, {}> {

    constructor(props) {
        super(props);

        this.state = {
            tableData: [],
            offset: 0,
            view: false
        };

        this.handlePageClick = this.handlePageClick.bind(this);
        this.viewClicked = this.viewClicked.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.tableData !== prevProps.tableData) {
            this.loadData();
        }
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * FACT_SHEET_TABLE_PAGE_SIZE);

        this.setState({ offset: offset }, () => {
            this.loadData();
        });
    };

    loadData() {
        if (this.props.tableData) {
            const all_data = this.props.tableData;
            const data = getPageSlice(this.props.tableData, this.state.offset, FACT_SHEET_TABLE_PAGE_SIZE);
            this.setState({ tableData: data, pageCount: getPageCount(all_data.length, FACT_SHEET_TABLE_PAGE_SIZE) });
        }
    }

    viewClicked() {
        if (!this.state.view)
            this.loadData();

        this.setState({
            view: !this.state.view
        });
    }

    renderLegislativeTable(repString) {
        if (this.state.tableData && this.state.tableData.length > 0) {
            return this.state.tableData.map((record, index) => {
                //(repString + record.rep).replace("Rep. Vacant", "Vacant").replace("Sen. Vacant", "Vacant")
                const repName = repString + record.rep;
                if (record.rep == "" || record.rep == null || record.rep == "Vacant") {
                    repName = "Vacant";
                }

                return (<tr key={index}>
                    <td style={{ "width": "200px" }}><b>{record.district}</b></td>
                    <td style={{ "width": "200px" }}>{repName}</td>
                    <td style={{ textAlign: "right", "width": "50px" }}>${toCurrency(record.latest ? record.latest : 0)}</td>
                    <td style={{ textAlign: "right", "width": "60px" }}>${toCurrency(record.range ? record.range : 0)}</td>
                </tr>);
            })
        } else {
            return <tr className="loading"><td>loading <i className="fa fa-spinner"></i></td></tr>;
        }

    }

    render() {
        const { statelegislative_heading, current_year, start_year, repString } = this.props;
        if (statelegislative_heading !== undefined)
            return (
                <div className="row">
                    <div className="col-md-12">
                        <h3>{renderHTML(statelegislative_heading)}</h3>
                        <table className="table">
                            <thead><tr><th colSpan={2} style={{ "width": "400px" }}>District</th>
                                <th style={{ "width": "50px", "textAlign": "right" }}>FY {current_year}</th>
                                <th style={{ "width": "60px", "textAlign": "right" }}>FY {`${start_year}-${current_year}`}</th>
                            </tr></thead>
                            <tbody>
                                {this.renderLegislativeTable(repString)}
                            </tbody>
                        </table>
                        <ReactPaginate previousLabel={"previous"}
                            nextLabel={"next"}
                            breakLabel={<a href="">...</a>}
                            breakClassName={"break-me"}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"} />
                    </div>
                </div>
            );
        return (<div></div>)
    }
}

export default StateLegislativeTable;